import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { CreateHorseComponent } from '../create-horse/create-horse.component';
import { SharedUIModuleModule } from 'src/app/shared/shared-uimodule/shared-uimodule.module';
import { NewHorseFormComponent } from '../new-horse-form/new-horse-form.component';
import { NewAddressFormComponent } from '../new-address-form/new-address-form.component';
import { RiderEditFormComponent } from '../rider-edit-form/rider-edit-form.component';

@Component({
  selector: 'ubc-modal',
  standalone: true,
  imports: [
    CommonModule,
    NewHorseFormComponent,
    NewAddressFormComponent,
    
    
  ],
  providers: [
    
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {

  constructor(
    public modalService: ModalService
  ){}


  closeClicked(){
    this.modalService.dismiss()
  }

  horseCreated(){
    this.modalService.dismiss()
  }
}

